// extracted by mini-css-extract-plugin
export default {"Heading":"use-tree-pane-module__Heading--iI_ad"};